import envVar from '../../../config/envVars';
import { TransformedStudentDetail } from '../../../types/userType';
import _ from 'lodash'; 
import { StudentPaymentSchemeWithMetrics } from '../../../types/paymentScheme';

export const generatePaymentImageUrl = (
  studentDetails: TransformedStudentDetail | null,
  academicYear: string,
  allPaymentSchemes: StudentPaymentSchemeWithMetrics[] 
): string => {
  if (!studentDetails || !academicYear) {
    return '';
  }

  const paymentsAPIBaseUrl = envVar.REACT_APP_PAYMENTS_API_BASE_URL;
  const studentId = studentDetails.studentDetails.id;
  const school = studentDetails.studentDetails.school;

  const currentRollOverInfo = studentDetails.studentDetails?.rollOverInfo?.find(
    (info) => info.academicYear === academicYear
  );

  const isNewAdmission = currentRollOverInfo?.isNewAdmission;
  const concessionsWaiversRemark =
    currentRollOverInfo?.concessionsWaiversRemark;
  const grade = currentRollOverInfo?.grade;

  let imageURL = `${paymentsAPIBaseUrl}/students/${studentId}/dynamic-fee-image/${academicYear}?school=${school}&isNewAdmission=${isNewAdmission}&grade=${grade}&concessionsWaiversRemark=${btoa(
    concessionsWaiversRemark || ''
  )}`;

  const selectedPaymentSchemes = allPaymentSchemes.filter(
    (ps) => ps.academicYear === academicYear && ps.particulars === 'Tuition Fee'
  );

  if (!_.isEmpty(selectedPaymentSchemes)) {
    const selectedSchemeName = selectedPaymentSchemes[0].scheme;
    const demandId = selectedPaymentSchemes[0].demandId;
    imageURL += `&selectedPaymentOption=${selectedSchemeName}&demandId=${demandId}`;
  }

  return imageURL;
};
